import { forwardRef } from 'react';

export const SquareDottedIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M1.71429 7.71429H0V12H4.28571V10.2857H1.71429V7.71429ZM0 4.28571H1.71429V1.71429H4.28571V0H0V4.28571ZM10.2857 10.2857H7.71429V12H12V7.71429H10.2857V10.2857ZM7.71429 0V1.71429H10.2857V4.28571H12V0H7.71429Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
